export default __webpack_public_path__ + "static/media/1938.f916c836.png";